import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=a9f50af0"
import script from "./ListCustomer.vue?vue&type=script&lang=js"
export * from "./ListCustomer.vue?vue&type=script&lang=js"
import style0 from "./ListCustomer.vue?vue&type=style&index=0&id=a9f50af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports